__turbopack_context__.v({
  "count": "_7jLZkG_count",
  "grid": "_7jLZkG_grid",
  "root": "_7jLZkG_root",
  "scopeTabs": "_7jLZkG_scopeTabs",
  "team": "_7jLZkG_team",
  "title": "_7jLZkG_title",
  "titleSec": "_7jLZkG_titleSec",
});
